import { render, staticRenderFns } from "./qualificationCertificate.vue?vue&type=template&id=5a3ba432&scoped=true&"
import script from "./qualificationCertificate.vue?vue&type=script&lang=js&"
export * from "./qualificationCertificate.vue?vue&type=script&lang=js&"
import style0 from "./qualificationCertificate.vue?vue&type=style&index=0&id=5a3ba432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ba432",
  null
  
)

export default component.exports